import { Route, Routes } from "react-router";

import { ItineraryPage } from "./pages/ItineraryPage";

/**
 * The itinerary routes, mounted at `/trips/:tripId/itinerary/*` (CHT-747):
 *   /trips/:tripId/itinerary                  the plan of record, else the newest draft
 *   /trips/:tripId/itinerary/:itineraryId     any revision of the trip (history is read-only)
 */
export function ItineraryRoutes() {
  return (
    <Routes>
      <Route index element={<ItineraryPage />} />
      <Route path=":itineraryId" element={<ItineraryPage />} />
    </Routes>
  );
}
